// libs
import React, { memo } from "react";
import styled from "@emotion/styled";

// global components
import BaseSearchInput from "shared/components/SearchInput";
import { SEARCH_INPUT_WIDTH } from "shared/components/Header/DesktopHeader/components/Menu/components/Category/components/Brands/constants";

// styles
const SearchInput = styled(BaseSearchInput)`
    width: ${SEARCH_INPUT_WIDTH}px;
    border: 0px;
    padding-left: 7px;
    height: 32px;
    border-radius: 2px;
    background-color: rgba(0, 18, 58, 0.08);
    font-size: 14px;

    & > .icon {
        color: #333;
        opacity: 0.36;
        font-size: 14px;
        font-weight: 600;
    }

    & > .input {
        height: 34px;
        color: #333;
        background-color: rgba(0, 18, 58, 0);

        &:placeholder {
            color: #ccc;
        }
    }
`;

const PLACEHOLDER = "Search Brands";

interface ISearchProps {
    onChange: (value: string) => void;
}

function Search({ onChange }: ISearchProps) {
    return <SearchInput onChange={onChange} placeHolder={PLACEHOLDER} />;
}

export default memo(Search);
